import React, { Component, Fragment } from 'react'
import ReactDOM from 'react-dom'
import { inject, observer } from 'mobx-react'
import { extendObservable, intercept, runInAction } from 'mobx'
import styled, { keyframes } from 'styled-components'
import { TweenMax } from 'gsap'
import DDSession from '@/Components/CommandHost/Common/DDSession'
import DDInterruption from '@/Components/CommandHost/Common/DDInterruption'
import DDMessage from '@/Components/CommandHost/Common/DDMessage'
import DDSponsorBrand from '@/Components/CommandHost/Common/DDSponsorBrand'
import PlayTypeIcon from '@/assets/images/preplay-type.png'
import PreviewIcon from '@/assets/images/preview-icon.svg'
import Team from '@/Components/Common/TeamIcon'
import { vhToPx, vwToPx, evalImage, guid } from '@/utils'
import UpArrowIcon from '@/assets/images/preplay-up-arrow-black.webp'
import WhiteArrowIcon from '@/assets/images/preplay-up-arrow-white.webp'
import DDAutomationController from '@/Components/CommandHost/Common/DDAutomationController'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faCircle,
  faAngleUp,
  faAngleDown,
} from '@fortawesome/free-solid-svg-icons'
import { responsiveDimension, uniqueId } from '../../utils'
import _, { forEach } from 'lodash'

const BACKGROUND = {
  light: '#eaeaea',
  dark: '#414042',
}

const PlayColors = {
  liveplay: '#c61818',
  gamemaster: '#19d1bf',
  sponsor: '#495bdb',
  prize: '#9368aa',
}

@inject(
  'PrePlayStore',
  'PlayStore',
  'CommandHostStore',
  'GameStore',
  'AutomationStore',
  'ImportStore',
  'CommonStore'
)
@observer
export default class HeaderPanel extends Component {
  constructor(props) {
    super(props)

    this.state = {
      buttonType: '',
      showDD: false,
      scoreInputValueA: 0,
      scoreInputValueB: 0,
      backgroundColor: BACKGROUND.light,
      showGameMasterVideoPanel: false,
      assetType: '',
      emptyGmMsgs: false,
      emptyGmVideos: false,
      showOptionalMessagesDropdown: false,
      selectPosition: {
        x: '',
        y: '',
        width: '',
      },
      selectedGMAsset: {
        item: {},
        id: '',
        type: '',
      },
      selectMoveButtons: [
        {
          id: 1,
          name: 'S',
        },
        {
          id: 2,
          name: 'L',
        },
        {
          id: 3,
          name: 'M',
        },
      ],
      selectedModes: [],
      isShowAssetsMenu: false,
      searchTxt: '',
      selectedCat: '',
      selectedAsset: '',
      selectedMessage: '',
      isHoverOnS: false,
    }
    this.increment = this.increment.bind(this)
    this.decrement = this.decrement.bind(this)
    FONT_SIZE = this.props.CommandHostStore.fontSize + 'vh'
    extendObservable(this, {
      item: '',
    })
    this._isMounted = false
    this.isShownDraggablePreview = false
    this.reference = 'play-option-'
    this.assetsRef = 'game-assets-'

    this.automationHeaderButtonStart = null

    this.preplaySequences = null

    this.destroyAddToStackItem = intercept(
      this.props.PrePlayStore,
      'addToStackItem',
      change => {
        if (!change.newValue) {
          this.resetHeaderPrePlayButtons()
        }
        return change
      }
    )

    this.destroyReusePlay = intercept(
      this.props.CommandHostStore,
      'reusePlay',
      change => {
        if (change.newValue) {
          const typeButton = this.props.PrePlayStore.TypeButtons.filter(
            o => o.type === change.newValue.type
          )[0]
          const args = {
            color: typeButton ? typeButton.color : '',
            id:
              'header-button-' +
              (change.newValue.type || 'liveplay').toLowerCase(),
            text: (change.newValue.type || 'liveplay').toLowerCase(),
            type: change.newValue.type || 'LivePlay',
            width: 'announce' === change.newValue.type.toLowerCase() ? 18 : 10,
            announcements: change.newValue.announcements,
            started: null,
            ended: null,
            resultConfirmed: false,
            sponsor: change.newValue.sponsor,
            sponsorId: change.newValue.sponsorId,
          }

          this.handleAddAssemblyClick(args)
        }
        return change
      }
    )

    this.destroyIsSyncCreatePlay = intercept(
      this.props.GameStore,
      'syncSessionCreatePlayResponded',
      change => {
        if (change.newValue) {
          this.syncAssembly(change.newValue)
        }
        return change
      }
    )

    this.destroySyncCreateSession = intercept(
      this.props.GameStore,
      'syncCreateSessionResponded',
      change => {
        if (change.newValue) {
          this.syncSession(change.newValue)
        }
        return change
      }
    )

    this.destroySyncCreateInterruption = intercept(
      this.props.GameStore,
      'syncCreateInterruptionResponded',
      change => {
        if (change.newValue) {
          this.syncInterruption(change.newValue)
        }
        return change
      }
    )

    this.destroySyncHeaderTeamChange = intercept(
      this.props.GameStore,
      'syncHeaderTeamResponded',
      change => {
        if (change.newValue) {
          this.syncHeaderTeamChange(change.newValue)
        }
        return change
      }
    )
  }

  handleOnChangeScoreInput(i, e) {
    let v
    if (e && e.target) {
      if (e.target.value && +e.target.value < 150) {
        v = e.target.value
        this.setTeamScore(i, v)
      } else if (!e.target.value) {
        this.setTeamScore(i, 0)
      }
    }
  }

  increment(i) {
    let v = this.props.PrePlayStore.teams[i]
      ? this.props.PrePlayStore.teams[i].score
      : 0
    v = v <= 150 ? v + 1 : 0
    this.setTeamScore(i, v)
  }

  decrement(i) {
    let v = this.props.PrePlayStore.teams[i]
      ? this.props.PrePlayStore.teams[i].score
      : 0
    v = v > 0 ? v - 1 : 0
    this.setTeamScore(i, v)
  }

  handleImportClick() {
    this.handleSessionButtonClick('import', this.automationHeaderButtonStart)
    this.props.importPlaystack()
  }

  handleShowPreviewClick(refId) {
    this.props.AutomationStore.addEvent({
      evt: 'click',
      refId: refId,
      wait: 0.5,
    })

    if (this.isShownDraggablePreview) {
      this.isShownDraggablePreview = false
      this.props.showPreview(false)
    } else {
      this.isShownDraggablePreview = true
      this.props.showPreview(true)
    }

    if (this._isMounted) {
      this.forceUpdate()
    }
  }

  resetHeaderPrePlayButtons() {
    for (let i = 0; i < this.props.PrePlayStore.TypeButtons.length; i++) {
      if ('Announce' === this.props.PrePlayStore.TypeButtons[i].type) {
        if (this[`type-button-${i}`]) {
          TweenMax.set(this[`type-button-${i}`], {
            color: '#000000',
            borderBottom: `${props => 0.5}vh; solid #000000`,
          })
        }
      }

      if (this[`type-button-${i}`]) {
        TweenMax.set(this[`type-button-${i}`], { backgroundColor: '#f1f2f2' })
      }
    }
  }

  setTeamScore(team_idx, score, syncGuid) {
    const key = 'scoreInputValue' + (team_idx ? 'B' : 'A')
    let _new_state = {}
    _new_state[key] = score
    this.setState(_new_state)
    this.props.GameStore.updateTeamScore(team_idx, parseInt(score))
    if (!syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'HEADER_TEAM_CHANGE',
        syncGuid: guid(),
        operator: this.props.GameStore.operator,
        args: { comp: 'header_team', index: team_idx, score: score },
      })
    }
  }

  RenderTeams(locked) {
    let comp = []
    if (!this.props.PrePlayStore.isLoading && this.props.PrePlayStore.teams) {
      for (let i = 0; i < this.props.PrePlayStore.teams.length; i++) {
        const team = this.props.PrePlayStore.teams[i]
        runInAction(() => (team.index = i))
        const automationTeamId = `header-team-${team.teamName}-${this.props.AutomationStore.headerPlaySequence}`
        const TeamBackgroundColor = team.possession ? '#18c5ff' : '#414042'
        const ScoreInputBackground = team.possession ? '#eaeaea' : 'gray'
        const ScoreInputColor = team.possession ? '#000' : '#fff'
        //const scoreInputValueA = team.score || this.state.scoreInputValueA
        //const scoreInputValueB = team.score || this.state.scoreInputValueB
        //const value = i === 0 ? scoreInputValueA : scoreInputValueB
        const value = team.score || 0
        comp.push(
          <TeamWrappercontainer style={{ borderRight: '1px solid #fff' }}>
            <TeamWrapper
              id={automationTeamId}
              key={i}
              onClick={
                locked
                  ? null
                  : this.handleSelectTeamClick.bind(
                      this,
                      { index: i },
                      automationTeamId
                    )
              }
              innerRef={ref => (this[`team-button-${i}`] = ref)}
              borderRight={i === 0 ? true : false}
              style={{
                backgroundColor: `${TeamBackgroundColor}`,
                alignItems: 'center',
                color: '#fff',
              }}
            >
              <TeamCircleWrapper>
                <Team
                  teamInfo={team}
                  size={3}
                  abbrSize={1.5}
                  outsideBorderColor={'#000000'}
                />
              </TeamCircleWrapper>
              <TeamLabel
                style={{
                  position: 'relative',
                  zIndex: 50,
                  maxWidth: '7.5vh',
                  maxWidth: '50%',
                  overflowY: 'auto',
                  overflow: 'hidden',
                }}
                title={team.teamName}
              >
                {team.teamName}
              </TeamLabel>
              <ScoreInputWrapper onClick={e => e.stopPropagation()}>
                <InputCircle
                  id={`team-score-input-circle-${i}`}
                  style={{ backgroundColor: `${TeamBackgroundColor}` }}
                />
                <ScoreInput
                  value={value}
                  style={{
                    backgroundColor: `${ScoreInputBackground}`,
                    color: `${ScoreInputColor}`,
                    ...(String(value).length === 2
                      ? { paddingLeft: '1.4vh' }
                      : String(value).length > 2
                      ? { paddingLeft: '1.1vh' }
                      : {}),
                  }}
                  onChange={this.handleOnChangeScoreInput.bind(this, i)}
                  maxLength={3}
                />
              </ScoreInputWrapper>
            </TeamWrapper>
            <CounterContainer>
              <IncrementButton onClick={this.increment.bind(this, i)}>
                <FontAwesomeIcon icon={faAngleUp} />
              </IncrementButton>
              <DecrementButton onClick={this.decrement.bind(this, i)}>
                <FontAwesomeIcon icon={faAngleDown} />
              </DecrementButton>
            </CounterContainer>
          </TeamWrappercontainer>
        )
      }

      return comp
    }

    return null
  }

  setActivePlayTab(playType) {
    this.props.PrePlayStore.TypeButtons.forEach((b, i) => {
      if (playType === b.type) {
        TweenMax.set(this[`type-button-${i}`], {
          backgroundColor: '#000000',
          color: 'white',
          borderBottom: `${props => 0.5}vh; solid white`,
        })
      } else {
        TweenMax.set(this[`type-button-${i}`], { backgroundColor: '#f1f2f2' })
      }
    })
  }

  syncAssembly(params) {
    params.args.syncGuid = params.syncGuid
    this.handleAddAssemblyClick(params.args, null)
  }

  syncSession(params) {
    params.args.syncGuid = params.syncGuid
    this.handleSessionValue(params.args)
  }

  syncInterruption(params) {
    params.args.syncGuid = params.syncGuid
    this.handleInterruptionValue(params.args)
  }

  syncMessage(params) {
    params.args.syncGuid = params.syncGuid
    this.handleMessageValue(params.args)
  }

  syncHeaderTeamChange(params) {
    params.args.syncGuid = params.syncGuid
    if (params.args.hasOwnProperty('score')) {
      this.setTeamScore(
        params.args.index,
        params.args.score,
        params.args.syncGuid
      )
    } else {
      this.handleSelectTeamClick(params.args)
    }
  }

  handleAddAssemblyClick(args) {
    if (false && !args.syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'CREATE_PLAY',
        syncGuid: guid(),
        args,
      })
    }

    this.props.PrePlayStore.setPresetItemObj(args)

    // if (refId) {
    //   this.props.AutomationStore.addEvent({
    //     evt: 'click',
    //     refId: refId,
    //     wait: 1,
    //   })
    //   this.props.GameStore.resetSyncCreatePlay()
    // }

    if (!this.props.GameStore.gameId) {
      return
    }

    for (let i = 0; i < this.props.PrePlayStore.TypeButtons.length; i++) {
      const btn = this.props.PrePlayStore.TypeButtons[i]
      if (args.type === btn.type) {
        if (btn.type === 'Announce') {
          this.props.PrePlayStore.subType = 'msg'
          TweenMax.set(this[`type-button-${i}`], {
            backgroundColor: '#000000',
            color: 'white',
            borderBottom: `${props => 0.5}vh; solid white`,
          })
        } else {
          TweenMax.set(this[`type-button-${i}`], { backgroundColor: '#000000' })
        }
      } else {
        if (btn.type === 'Announce') {
          TweenMax.set(this[`type-button-${i}`], {
            backgroundColor: '#f1f2f2',
            color: 'black',
            borderBottom: `${props => 0.5}vh; solid black`,
          })
        } else {
          TweenMax.set(this[`type-button-${i}`], { backgroundColor: '#f1f2f2' })
        }
      }
    }

    this.props.PrePlayStore.setAddToStackItem(null)
    this.announceValues = []

    const item = {
      index: 0,
      type: args.type,
      playTitle: {},
      choices: [],
      stars: null,
    }

    if (args.game_moment) {
      const parts = String(args.game_moment).split('|')
      const placement = parts[0] ? parts[0].trim() : null
      const moment = parts.length > 1 && parts[1] ? parts[1].trim() : null

      item.pmetadata = item.pmetadata || {}
      item.pmetadata.public = item.pmetadata.public || {}

      if (placement) {
        item.pmetadata.public.placement = placement
      }
      if (moment) {
        item.pmetadata.public.moment = moment
      }
    }

    if ('Announce' === args.type) {
      item.sponsorExpanded = false
      item.announcements = []

      if (this.announceValues && this.announceValues.length > 0) {
        if (this.props.PrePlayStore.sessionButtons['interruption'].text) {
          this.announceValues[0].value = this.props.PrePlayStore.sessionButtons[
            'interruption'
          ].text
        }
        item.announcements.push(this.announceValues[0])
        item.announcements.push(this.announceValues[1])
        item.announcements.push(this.announceValues[2])
      } else {
        item.announcements.push({ area: 'header', value: '' })
        item.announcements.push({ area: 'middle', value: '' })
        item.announcements.push({ area: 'bottom', value: '' })
      }
    }
    item.preset_n_id = args.id

    setTimeout(() => {
      this.props.PrePlayStore.setAddToStackItem(item)
    }, 0)
  }

  handleSessionButtonClick(sessionType, refId) {
    this.props.PrePlayStore.setAddToStackItem(null)
    // if ('start' === sessionType) {
    //   this.sessionStart()
    // } else if ('end' === sessionType) {
    //   this.sessionEnd()
    // }

    /*
    if (sessionType === 'start') {
      this.props.sessionStartEnd(sessionType)
    } else {
      if (window.confirm(sessionType.toUpperCase() + ' SESSION?')) {
        this.props.sessionStartEnd(sessionType)
      }
    }
*/

    /*
    if (this.props.PrePlayStore.sessionButtons['start'] && (this.props.PrePlayStore.sessionButtons['start'].text || '').toLowerCase() === 'resume session') {
      this.props.sessionStartEnd('resume')
    } else if (this.props.PrePlayStore.sessionButtons['start'] && (this.props.PrePlayStore.sessionButtons['start'].text || '').toLowerCase() === 'pause') {
      this.props.sessionStartEnd('pause')
    } else {
      this.props.AutomationStore.addEvent({evt:'click', refId: refId, wait: 2, isIncrementHeaderPlaySequence: true})

      this.props.sessionStartEnd(sessionType)
    }
*/

    if ('start' === sessionType.toLowerCase()) {
      if (
        this.props.PrePlayStore.sessionButtons['start'] &&
        (
          this.props.PrePlayStore.sessionButtons['start'].text || ''
        ).toLowerCase() === 'resume session'
      ) {
        this.props.sessionStartEnd('resume')
      } else if (
        this.props.PrePlayStore.sessionButtons['start'] &&
        (
          this.props.PrePlayStore.sessionButtons['start'].text || ''
        ).toLowerCase() === 'pause'
      ) {
        this.props.sessionStartEnd('pause')
      } else {
        this.props.AutomationStore.addEvent({
          evt: 'click',
          refId: refId,
          wait: 2,
          isIncrementHeaderPlaySequence: true,
        })
        this.props.sessionStartEnd(sessionType)
      }
    } else if ('end' === sessionType.toLowerCase()) {
      this.props.AutomationStore.addEvent({
        evt: 'click',
        refId: refId,
        wait: 2,
        isIncrementHeaderPlaySequence: true,
      })
      this.props.sessionStartEnd(sessionType)
    } else if ('import' === sessionType.toLowerCase()) {
      if (
        this.props.PrePlayStore.sessionButtons['start'] &&
        (
          this.props.PrePlayStore.sessionButtons['start'].text || ''
        ).toLowerCase() === 'pause'
      ) {
        this.props.sessionStartEnd('pause')
      }
    }
  }

  handleAutomationAddEvent(params) {
    this.props.AutomationStore.addEvent(params)
  }

  handleToggleBgColor() {
    const bg =
      this.state.backgroundColor === BACKGROUND.light
        ? BACKGROUND.dark
        : BACKGROUND.light
    this.setState({
      backgroundColor: bg,
    })
    document.querySelectorAll('.pre_pick_container').forEach(ele => {
      ele.style.backgroundColor = bg
    })
    document.getElementById(
      'resolved_panel_container'
    ).style.backgroundColor = bg
    if (
      document.getElementById('assembly-panel-stack') &&
      document.getElementById('assembly-panel-stack').style
    )
      document.getElementById('assembly-panel-stack').style.backgroundColor = bg
    document.getElementById(
      'all_stack_container_to_go'
    ).style.backgroundColor = bg
    document.getElementById(
      'pre_load_play_container_stack'
    ).style.backgroundColor = bg
    document.getElementById(
      'un_resolved_container_play_stacks'
    ).style.backgroundColor = bg
    if (
      document.getElementById('empty_cont_behind_header') &&
      document.getElementById('empty_cont_behind_header').style
    )
      document.getElementById(
        'empty_cont_behind_header'
      ).style.backgroundColor = bg
    if (
      ['recording', 'automation'].includes(
        this.props.GameStore.executionType
      ) &&
      document.getElementById('blocker_message_id') &&
      document.getElementById('blocker_message_id').style
    ) {
      document.getElementById('blocker_message_id').style.color =
        bg === BACKGROUND.dark ? '#fff' : '#000'
    }
  }

  handleSessionValue(val) {
    if (false && !val.syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'CREATE_SESSION',
        syncGuid: guid(),
        args: val,
      })
    }

    this.props.PrePlayStore.subType = 'time_period'
    this.props.GameStore.resetSyncCreatePlay()

    this.props.PrePlayStore.sessionButtons['session'].text = val.name

    if (val.name) {
      this.announceValues = [
        { area: 'header', value: val.header },
        {
          area: 'middle',
          value: val.middle,
        },
        {
          area: 'bottom',
          value: val.bottom,
        },
      ]
    } else {
      this.announceValues = [
        { area: 'header', value: '' },
        { area: 'middle', value: '' },
        { area: 'bottom', value: '' },
      ]
    }

    this.props.PrePlayStore.setAddToStackItem(null)
    this.setActivePlayTab('Announce')
    setTimeout(() => {
      let item = {
        index: 0,
        type: 'Announce',
        playTitle: '',
        choices: [],
        stars: 0,
        announcements: [],
      }

      if (val && val.game_moment) {
        const parts = String(val.game_moment).split('|')
        const placement = parts[0] ? parts[0].trim() : null
        const moment = parts.length > 1 && parts[1] ? parts[1].trim() : null

        if (!item.pmetadata) item.pmetadata = {}
        if (!item.pmetadata.public) item.pmetadata.public = {}
        if (placement) item.pmetadata.public.placement = placement
        if (moment) item.pmetadata.public.moment = moment
      }

      item.announcements.push(this.announceValues[0])
      item.announcements.push(this.announceValues[1])
      item.announcements.push(this.announceValues[2])

      item.preset_n_id = val.id
      item.subType = 'time_period'
      this.props.PrePlayStore.setAddToStackItem(item)
    }, 0)
  }

  handleInterruptionValue(val) {
    if (false && !val.syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'CREATE_INTERRUPTION',
        syncGuid: guid(),
        args: val,
      })
    }

    this.props.PrePlayStore.subType = 'interrupt'
    this.props.GameStore.resetSyncCreatePlay()

    if (val.name) {
      this.announceValues = [
        { area: 'header', value: val.header },
        {
          area: 'middle',
          value: val.middle,
        },
        {
          area: 'bottom',
          value: val.bottom,
        },
      ]
    } else {
      this.announceValues = [
        { area: 'header', value: '' },
        { area: 'middle', value: '' },
        { area: 'bottom', value: '' },
      ]
    }

    this.props.PrePlayStore.setAddToStackItem(null)
    this.setActivePlayTab('Announce')
    setTimeout(() => {
      let item = {
        index: 0,
        type: 'Announce',
        playTitle: '',
        choices: [],
        stars: 0,
        announcements: [],
      }

      if (val && val.game_moment) {
        const parts = String(val.game_moment).split('|')
        const placement = parts[0] ? parts[0].trim() : null
        const moment = parts.length > 1 && parts[1] ? parts[1].trim() : null

        if (!item.pmetadata) item.pmetadata = {}
        if (!item.pmetadata.public) item.pmetadata.public = {}
        if (placement) item.pmetadata.public.placement = placement
        if (moment) item.pmetadata.public.moment = moment
      }

      item.announcements.push(this.announceValues[0])
      item.announcements.push(this.announceValues[1])
      item.announcements.push(this.announceValues[2])

      item.preset_n_id = val.id
      item.subType = 'interrupt'
      this.props.PrePlayStore.setAddToStackItem(item)
    }, 0)
  }

  handleMessageValue(val) {
    if (false && !val.syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'CREATE_PLAY',
        syncGuid: guid(),
        args: val,
      })
    }

    this.props.PrePlayStore.subType = val.subType ? val.subType : 'msg'
    this.props.GameStore.resetSyncCreatePlay()

    if (val.name) {
      this.announceValues = [
        { area: 'header', value: val.header },
        {
          area: 'middle',
          value: val.middle,
        },
        {
          area: 'bottom',
          value: val.bottom,
        },
      ]
    } else {
      this.announceValues = [
        { area: 'header', value: '' },
        { area: 'middle', value: '' },
        { area: 'bottom', value: '' },
      ]
    }

    this.props.PrePlayStore.setAddToStackItem(null)
    this.setActivePlayTab('Announce')
    setTimeout(() => {
      let item = {
        index: 0,
        type: 'Announce',
        playTitle: '',
        choices: [],
        stars: 0,
        announcements: [],
      }

      if (val && val.game_moment) {
        const parts = String(val.game_moment).split('|')
        const placement = parts[0] ? parts[0].trim() : null
        const moment = parts.length > 1 && parts[1] ? parts[1].trim() : null

        if (!item.pmetadata) item.pmetadata = {}
        if (!item.pmetadata.public) item.pmetadata.public = {}
        if (placement) item.pmetadata.public.placement = placement
        if (moment) item.pmetadata.public.moment = moment
      }

      item.announcements.push(this.announceValues[0])
      item.announcements.push(this.announceValues[1])
      item.announcements.push(this.announceValues[2])

      item.preset_n_id = val.id
      item.subType = val.subType
      this.props.PrePlayStore.setAddToStackItem(item)
    }, 0)
  }

  handleSelectedSponsor(val) {
    this.props.PrePlayStore.setSelectedSponsor(val)
  }

  resetSessionButtons() {
    this.props.PrePlayStore.sessionButtons['start'] = {
      backgroundColor: '#18c5ff',
      color: '#000000',
      text: 'start session',
      locked: true,
    }
  }

  handleSelectTeamClick(params, automationTeamId) {
    let newIndex = params.index
    const isDeselecting = params.index === -1 || params.index === null

    if (!isDeselecting && !params.syncGuid) {
      const clickedTeam = this.props.PrePlayStore.teams[params.index]
      const isCurrentlySelected =
        this.props.PrePlayStore.selectedTeam === clickedTeam ||
        clickedTeam.possession
      if (isCurrentlySelected) {
        newIndex = null
      }
    }

    if (!params.syncGuid) {
      this.props.GameStore.syncRequest({
        processName: 'HEADER_TEAM_CHANGE',
        syncGuid: guid(),
        operator: this.props.GameStore.operator,
        args: { comp: 'header_team', index: newIndex, automationTeamId },
      })
    }

    if (automationTeamId) {
      this.props.AutomationStore.addEvent({
        evt: 'click',
        refId: automationTeamId,
        wait: 0.5,
        isIncrementHeaderPlaySequence: true,
      })
    }

    if (newIndex === -1 || newIndex === null) {
      this.props.PrePlayStore.setSelectedTeam(null)
    }

    for (let i = 0; i < this.props.PrePlayStore.teams.length; i++) {
      const teamButton = this[`team-button-${i}`]
      const newPossession = i === newIndex ? 1 : 0
      this.props.PrePlayStore.teams[i].possession = newPossession
      this.props.GameStore.updateTeamPossession(i, newPossession)
      if (i === newIndex) {
        this.props.PrePlayStore.setSelectedTeam(
          this.props.PrePlayStore.teams[i]
        )
        TweenMax.set(teamButton, {
          backgroundColor: '#18c5ff',
          color: '#ffffff',
        })
        document.getElementById(
          `team-score-input-circle-${i}`
        ).style.backgroundColor = '#18c5ff'
      } else {
        TweenMax.set(teamButton, {
          backgroundColor: '#414042',
          color: '#ffffff',
        })
        document.getElementById(
          `team-score-input-circle-${i}`
        ).style.backgroundColor = '#414042'
      }
    }
    this.forceUpdate()
  }

  handleResetDBClick() {
    this.props.resetDatabase()
  }

  handleResetDBClickX1() {
    if (window.confirm('RESET DATABASE?')) {
      if (this.ResetDBPromptPanel) {
        TweenMax.to(this.ResetDBPromptPanel, 0.1, {
          visibility: 'visible',
          opacity: 1,
        })

        this.props.PlayStore.resetDatabase(next => {
          if (next) {
            TweenMax.to(this.ResetDBPromptPanel, 0.1, {
              opacity: 0,
              onComplete: () => {
                TweenMax.set(this.ResetDBPromptPanel, { visibility: 'hidden' })
              },
            })

            window.open('', '_self', '').close()
            setTimeout(() => {
              window.location.reload(true)
            }, 0)
          } else {
            TweenMax.to(this.ResetDBPromptPanel, 0.1, {
              opacity: 0,
              onComplete: () => {
                TweenMax.set(this.ResetDBPromptPanel, { visibility: 'hidden' })
                if (this.ErrorPromptPanel) {
                  TweenMax.to(this.ErrorPromptPanel, 0.1, {
                    visibility: 'visible',
                    opacity: 1,
                  })
                }
              },
            })
          }
          window.location.reload(true)
        })
      }

      this.resetSessionButtons()
    }
  }

  handleControlClick(automationAction) {
    this.props.control(automationAction)
  }

  handleRecordingResetClick() {
    this.props.resetRecording()
  }

  initOptionEventListener(mode, type) {
    let func = evt => {
      const option =
        type === 'assets'
          ? this[`${this.assetsRef}`]
          : this[`${this.reference}`]

      console.log('REF INIT', option)

      if (option) {
        let targetElement = evt.target // clicked element

        do {
          if (targetElement == option) {
            // This is a click inside. Do nothing, just return.
            return
          }
          // Go up the DOM
          targetElement = targetElement.parentNode
        } while (targetElement)

        // This is a click outside.
        if (option.classList.contains('open')) {
          option.className = option.className.replace(' open', '')
          this.setState({ showDD: false })
          // if (type === 'assets') {
          //   this.setState({
          //     showGameMasterVideoPanel: false,
          //     showOptionalMessagesDropdown: false,
          //   })
          // }
        }
        document.removeEventListener('click', func)
      }
    }

    if (mode === 0) {
      document.removeEventListener('click', func)
    } else {
      document.addEventListener('click', func)
    }
  }

  handleButtonClick(refId) {
    this.setState({
      buttonType: refId,
      showDD: true,
      isShowAssetsMenu: false,
      assetType: '',
      selectedCat: '',
      selectedAsset: '',
      selectedMessage: '',
      selectedGMAsset: {
        item: null,
        id: '',
        type: '',
      },
      // showOptionalMessagesDropdown: false,
    })

    const option = this[`${this.reference}`]
    console.log('REF', option)
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        TweenMax.to(option, 0.3, { visibility: 'hidden' })
        this.setState({ showDD: false })
      } else {
        setTimeout(() => {
          this.initOptionEventListener(1)
          option.className += ' open'
          TweenMax.to(option, 0.3, { visibility: 'visible' })
        }, 0)
      }
    }

    // if (this.props.automationAddEvent) {
    //   this.props.automationAddEvent({
    //     evt: 'click',
    //     refId: refId,
    //     wait: 0.5,
    //     isIncrementHeaderPlaySequence: true,
    //   })
    // }
  }

  handleGameMasterMenu = (type, e) => {
    const { isShowAssetsMenu } = this.state
    this.setState({
      isShowAssetsMenu: !isShowAssetsMenu,
      assetType: type,
      selectedCat: '',
      selectedAsset: '',
      selectedMessage: '',
      selectedGMAsset: {
        item: null,
        id: '',
        type: '',
      },
      // showOptionalMessagesDropdown: false,
    })
    // const rect = e && e.target.getBoundingClientRect()
    // this.setState({ overLayLeft: rect && rect.left })
    // const option = this[`${this.assetsRef}`]
    // console.log('REF', option)
    // if (option) {
    //   if (option.classList.contains('open')) {
    //     this.initOptionEventListener(0, 'assets')
    //     option.className = option.className.replace(' open', '')
    //     TweenMax.to(option, 0.3, { visibility: 'hidden' })
    //     this.setState({ showGameMasterVideoPanel: false })
    //   } else {
    //     setTimeout(() => {
    //       this.initOptionEventListener(1, 'assets')
    //       option.className += ' open'
    //       TweenMax.to(option, 0.3, { visibility: 'visible' })
    //     }, 0)
    //   }
    // }
  }

  getRowButtonBackground(button) {
    return button && button.text && button.text.toLowerCase() === 'live'
      ? '#c61818'
      : button.text.toLowerCase() === 'gamemaster'
      ? '#19d1bf'
      : button.text.toLowerCase() === 'sponsor'
      ? '#495bdb'
      : button.text.toLowerCase() === 'prize'
      ? '#9368aa'
      : button.text.toLowerCase() === 'announce'
      ? '#000000'
      : '#f1f2f2'
  }

  handleOptionItemClick(item, refId) {
    this.setState({ showDD: false })
    let preItems = this.props.PrePlayStore.getPresetItemsByType(
      this.state.buttonType
    )

    if (this.state.buttonType == 'Announce') {
      this.handleMessageValue(
        this.props.PrePlayStore.messagePlays.filter(o => o.name == item.name)[0]
      )
    } else this.handleAddAssemblyClick(preItems.filter(o => o.id == item.id)[0])

    const option = this[`${this.reference}${this.props.index}`]
    if (option) {
      if (option.classList.contains('open')) {
        this.initOptionEventListener(0)
        option.className = option.className.replace(' open', '')
        TweenMax.to(option, 0.3, { visibility: 'visible', zIndex: -1000 })
      }

      this.item = item
    }

    if (this.props.automationAddEvent) {
      this.props.automationAddEvent({
        evt: 'click',
        refId: refId,
        wait: 0.5,
        isIncrementHeaderPlaySequence: true,
      })
    }
  }

  handleGameAssetsClick(clickedItem, id, type, index, event) {
    const clickedElement = event.currentTarget
    const { left, top, width } =
      (clickedElement && clickedElement.getBoundingClientRect()) || {}
    const { item } = this.state.selectedGMAsset
    if (!item || item !== clickedItem) {
      this.setState({
        // showOptionalMessagesDropdown: true,
        selectPosition: {
          x: left,
          y: top,
          width,
        },
        selectedGMAsset: {
          item: clickedItem,
          id: id,
          type: type,
        },
      })
    } else {
      this.setState({
        // showOptionalMessagesDropdown: false,
        selectPosition: {
          x: '',
          y: '',
          width: '',
        },
        selectedGMAsset: {
          item: null,
          id: '',
          type: '',
        },
      })
    }
    this.forceUpdate()
  }

  handleGmAnnounceMenuOptionClick(optionalItem, index) {
    const { item, id, type } = this.state.selectedGMAsset
    this.props.PrePlayStore.setGmAnnouncement()
    if (id) {
      this.props.PrePlayStore.subType = `gm_announce_${type}`
    }
    let gmAnnouncePlay = {}
    const clickedGMAnnounce = {
      name: item.name,
      asset: item.asset,
      id: item.id,
      quantity: item.quantity,
      messageSequence: optionalItem.id,
      gm_id: this.state.selectedCat.category_id,
    }
    this.props.PlayStore.setGmAsset(clickedGMAnnounce)
    let stringifiedAsset = JSON.stringify(clickedGMAnnounce)
    gmAnnouncePlay.bottom = optionalItem.bottom + stringifiedAsset
    gmAnnouncePlay.header = optionalItem.header
    gmAnnouncePlay.middle = optionalItem.middle
    gmAnnouncePlay.name = 'gm_vid_announce'
    gmAnnouncePlay.subType = `gm_announce_${type}`
    gmAnnouncePlay.playTitle = { value: 'gm_video' }
    gmAnnouncePlay.title = type === 'msg' ? 'VID MES' : 'GM MES'
    gmAnnouncePlay.game_moment = optionalItem.game_moment
    gmAnnouncePlay.id = optionalItem.id
    this.handleMessageValue(gmAnnouncePlay)
    // this.handleGameMasterMenu(type)
    this.setState({
      selectedCat: '',
      selectedAsset: '',
      selectedMessage: '',
      selectedGMAsset: {
        item: null,
        id: '',
        type: '',
      },
      isShowAssetsMenu: false,
    })
  }

  handleAddToStackValues(values) {
    this.props.PrePlayStore.setIsAddingStack(true)
    this.props.PrePlayStore.setAddToStackItem(null)

    //this.props.PlayStore.addThePlay(values)

    this.props.GameStore.syncRequest({
      processName: 'ADD_PLAY',
      gameId: this.props.GameStore.gameId,
      syncGuid: 'abc123',
    })
    this.props.GameStore.addThePlay(values)

    if (!this.props.PrePlayStore.nextPlayItem) {
      this.setSessionButtonValues({ type: 'start', locked: false })
    }
  }

  // displayAssets(data, type, subType) {
  //   let header = type.includes('game') ? 'GAME ASSETS' : 'SPORT TYPE ASSETS'
  //   let dataRetrieval = type.includes('game') ? 'game' : 'sport_type'
  //   let subDataRetrieval = subType.includes('msg') ? 'msg' : 'video'
  //   return (
  //     <AssetsContainer pTop={type.includes('game') ? 1.5 : 0}>
  //       <Headercontainer>
  //         <HorizontalBar
  //           width={'100%'}
  //           height={0.1}
  //           mLeft={'3%'}
  //         ></HorizontalBar>
  //         <HeaderName width={'100%'}>{header}</HeaderName>
  //         <HorizontalBar
  //           width={'100%'}
  //           height={0.1}
  //           mRight={'3%'}
  //         ></HorizontalBar>
  //       </Headercontainer>
  //       <ListContainer>
  //         {data &&
  //         data[dataRetrieval] &&
  //         data[dataRetrieval][subDataRetrieval] &&
  //         data[dataRetrieval][subDataRetrieval].length > 0 ? (
  //           _.orderBy(
  //             data[dataRetrieval][subDataRetrieval],
  //             ['sort_order', 'name'],
  //             ['asc', 'asc']
  //           ).map((item, i) => {
  //             const gameAssetsDropdownOptionId = `game-assets-${type}-${subType}-dropdown-video-option-${i}`
  //             return (
  //               <OptionItem
  //                 innerRef={ref => (this[`game_asset-option-item-${i}`] = ref)}
  //                 id={gameAssetsDropdownOptionId}
  //                 // opaque={item.quantity <= item.servedQuantity}
  //                 style={{
  //                   display: 'flex',
  //                 }}
  //                 key={i}
  //                 onClick={e => {
  //                   e.stopPropagation()
  //                   // if (item.quantity > item.servedQuantity)
  //                   this.handleGameAssetsClick(
  //                     item,
  //                     gameAssetsDropdownOptionId,
  //                     subType,
  //                     i,
  //                     e
  //                   )
  //                 }}
  //                 assetsOption={true}
  //               >
  //                 <Item color={'#333'} width={'75%'}>
  //                   {item.name ? item.name : '-'}
  //                 </Item>
  //                 <ServingCounter>
  //                   <Item color={'#333'} noWidth={true}>
  //                     {item.servedQuantity || 0}
  //                   </Item>
  //                   <Item color={'#333'} whiteSpace={'pre'} noWidth={true}>
  //                     {' /'}
  //                   </Item>
  //                   <Item color={'#333'} whiteSpace={'pre'} noWidth={true}>
  //                     {` ${item.quantity || 0}`}
  //                   </Item>
  //                 </ServingCounter>
  //               </OptionItem>
  //             )
  //           })
  //         ) : (
  //           <Item color={'#c2c7c7'} padding={'3%'} noAssets={true}>
  //             {'No Assets Loaded...'}
  //           </Item>
  //         )}
  //       </ListContainer>
  //     </AssetsContainer>
  //   )
  // }

  areGmAssetsEmpty(data, type) {
    if (data) {
      const gameMsgs =
        data.game && data.game[type] && data.game[type].length > 0
      const sportTypeMsgs =
        data.sport_type &&
        data.sport_type[type] &&
        data.sport_type[type].length > 0
      return !gameMsgs && !sportTypeMsgs
    }
    return true
  }

  handleSelectMoveClick(button) {
    let { selectedModes = [] } = this.state

    const doUpdateselectModes = () => {
      if (!selectedModes.includes(button)) {
        selectedModes.push(button)
      } else {
        if (button === 'S') {
          selectedModes = []
        } else _.remove(selectedModes, mode => mode === button)
      }
    }

    if (button === 'M') {
      if (
        selectedModes.includes('S') &&
        this.props.CommonStore.selectionMode &&
        (this.props.CommonStore.selectionMode.sModePlays || []).length &&
        selectedModes.includes('L') &&
        this.props.CommonStore.selectionMode.destinationItem
      ) {
        this.preplaySequences = this.props.PrePlayStore.preplayItems.map(
          _p => _p.sequence
        )
        doUpdateselectModes()
        this.props.CommonStore.setSelectionClickStatus(button)
        this.makeMoveSelectedPlays()
      }
    } else if (button === 'L') {
      if (
        selectedModes.includes('S') &&
        this.props.CommonStore.selectionMode &&
        (this.props.CommonStore.selectionMode.sModePlays || []).length
      ) {
        doUpdateselectModes()
        this.props.CommonStore.setSelectionClickStatus(button)
      }
    } else if (button === 'S') {
      doUpdateselectModes()
      this.props.CommonStore.setSelectionClickStatus(button)
    }
    this.setState({ selectedModes: selectedModes })
  }

  handleSelectRemoveAction = event => {
    forEach(this.props.CommonStore.selectionMode.sModePlays, play => {
      setTimeout(() => {
        this.props.GameStore.removePlay(play)
      }, 1500)
    })
  }

  handleMouseEnterSBtn() {
    this.setState({ isHoverOnS: true })
  }

  handleMouseLeaveSBtn() {
    this.setState({ isHoverOnS: false })
  }

  async makeMoveSelectedPlays() {
    if (this.props.CommonStore.selectionMode) {
      const newArray = _.reverse(
        this.props.CommonStore.selectionMode.sModePlays || []
      )
      const destination = this.props.CommonStore.selectionMode.destinationItem
      this.props.CommonStore.selectionMode.sModePlays.forEach(play => {
        _.remove(
          this.props.PrePlayStore.preplayItems,
          prePlayItem => prePlayItem.gamePlayId === play.gamePlayId
        )
      })
      const destinationIndex = (
        this.props.PrePlayStore.preplayItems || []
      ).findIndex(
        prePlayItem => prePlayItem.gamePlayId === destination.gamePlayId
      )
      this.props.PrePlayStore.preplayItems.splice(
        destinationIndex + 1,
        0,
        ...newArray
      )
      let arr = []
      for (let _i = 0; _i < this.props.PrePlayStore.preplayItems.length; ++_i) {
        if (
          this.preplaySequences[_i] ===
          this.props.PrePlayStore.preplayItems[_i].sequence
        )
          continue
        this.props.PrePlayStore.preplayItems[
          _i
        ].sequence = this.preplaySequences[_i]
        arr.push({
          id: this.props.PrePlayStore.preplayItems[_i].gamePlayId,
          sequence: this.preplaySequences[_i],
        })
      }
      if ((arr || []).length) {
        await this.props.PlayStore.movePlay({
          gameId: this.props.GameStore.gameId,
          plays: JSON.stringify(arr),
        })
      }
      this.preplaySequences = null
      this.props.CommonStore.resetSelectionMode()
      let selectedModes = []
      await this.setState({ selectedModes: selectedModes })
    }
  }

  isCurrentModeActive(button) {
    return (this.state.selectedModes || []).includes(button)
  }

  isPrepicksResolved() {
    return (
      !(this.props.GameStore.prePicks || []).length ||
      this.props.GameStore.prePicks.findIndex(pp => {
        return pp && (!pp.correctChoice || !pp.correctChoice.value)
      }) === -1
    )
  }

  handleOnSearch(e) {
    e.preventDefault()
    if (e && e.target) {
      this.setState({ searchTxt: e.target.value || '', selectedAsset: '' })
    }
  }

  handleAssetListItemClick(type, item, index) {
    if (type === 'categories') {
      this.setState(prevState => ({
        selectedCat: item ? item : prevState.selectedCat,
      }))
    } else if (type === 'assets') {
      this.setState(prevState => ({
        selectedAsset: item ? item : prevState.selectedAsset,
        selectedGMAsset: {
          item: item,
          id: `game-assets-${this.state.assetType}-dropdown-video-option-${index}`,
          type: this.state.assetType,
        },
      }))
    } else if (type === 'messages') {
      this.setState(prevState => ({
        selectedMessage: item ? item : prevState.selectedAsset,
      }))
      this.handleGmAnnounceMenuOptionClick(item)
    }
  }

  renderAssetListItems(type, list, selectedItem, mRight, nameKey) {
    let selectedAssetCounts = 0
    if (type === 'assets') {
      selectedAssetCounts =
        this.props.GameStore.servedAssetsCounts &&
        this.props.GameStore.servedAssetsCounts[
          this.state.selectedCat.category_id
        ] &&
        this.props.GameStore.servedAssetsCounts[
          this.state.selectedCat.category_id
        ][selectedItem.id]
          ? this.props.GameStore.servedAssetsCounts[
              this.state.selectedCat.category_id
            ][selectedItem.id].totalCount
          : 0
    }
    return (
      <AssetListContainer
        type={type}
        mRight={mRight}
        length={(list || []).length}
      >
        <ListHeader>
          {type === 'messages' ? (
            'GM MES'
          ) : selectedItem ? (
            type === 'assets' ? (
              <ListItemCat
                key={`item_${uniqueId()}`}
                style={{ padding: `${responsiveDimension(0.4)} 0 0` }}
              >
                <Text
                  width={'100%'}
                  wrap={'nowrap'}
                  mRight={'5px'}
                  style={{ flex: 1, minWidth: 0 }}
                >
                  {(() => {
                    const name = selectedItem[nameKey] || ''
                    const match = name.match(/[_-](\d+")$|(\d+")$/)
                    if (match) {
                      const timing = match[1] || match[2]
                      const baseName = name.replace(/[_-]\d+"$|\d+"$/, '')
                      return (
                        <div
                          style={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            width: '100%',
                            paddingRight: '10%',
                          }}
                        >
                          <span
                            style={{
                              overflow: 'hidden',
                              textOverflow: 'ellipsis',
                            }}
                          >
                            {baseName}
                          </span>
                          <span
                            style={{ minWidth: '3.5vh', textAlign: 'right' }}
                          >
                            {timing}
                          </span>
                        </div>
                      )
                    }
                    return name
                  })()}
                </Text>
                <Text flexShrink={0} wrap={'nowrap'}>
                  {selectedAssetCounts}
                  {'/'}
                  {selectedItem['quantity']}
                </Text>
              </ListItemCat>
            ) : (
              selectedItem[nameKey]
            )
          ) : type === 'categories' ? (
            this.state.assetType === 'video' ? (
              'GAMEMASTERS'
            ) : (
              'BRANDS'
            )
          ) : type === 'assets' ? (
            'GM MES VID'
          ) : null}
        </ListHeader>
        <ListBody length={(list || []).length}>
          {(list || []).map((item, index) => {
            if (item) {
              let servedCount = 0
              if (type === 'categories') {
                servedCount =
                  this.props.GameStore.servedAssetsCounts &&
                  this.props.GameStore.servedAssetsCounts[item.category_id]
                    ? this.props.GameStore.servedAssetsCounts[item.category_id]
                        .totalCount
                    : 0
              } else if (type === 'assets') {
                servedCount =
                  this.props.GameStore.servedAssetsCounts &&
                  this.props.GameStore.servedAssetsCounts[
                    this.state.selectedCat.category_id
                  ] &&
                  this.props.GameStore.servedAssetsCounts[
                    this.state.selectedCat.category_id
                  ][item.id]
                    ? this.props.GameStore.servedAssetsCounts[
                        this.state.selectedCat.category_id
                      ][item.id].totalCount
                    : 0
              } else {
                servedCount =
                  this.props.GameStore.servedAssetsCounts &&
                  this.props.GameStore.servedAssetsCounts[
                    this.state.selectedCat.category_id
                  ] &&
                  this.props.GameStore.servedAssetsCounts[
                    this.state.selectedCat.category_id
                  ][this.state.selectedAsset.id] &&
                  this.props.GameStore.servedAssetsCounts[
                    this.state.selectedCat.category_id
                  ][this.state.selectedAsset.id][item.id]
                    ? this.props.GameStore.servedAssetsCounts[
                        this.state.selectedCat.category_id
                      ][this.state.selectedAsset.id][item.id]
                    : 0
              }
              return (
                <ListItemCat
                  key={`item_${uniqueId()}`}
                  onClick={this.handleAssetListItemClick.bind(
                    this,
                    type,
                    item,
                    index
                  )}
                  isSelected={selectedItem ? selectedItem === item : false}
                >
                  <Text
                    width={'100%'}
                    wrap={'nowrap'}
                    mRight={'5px'}
                    style={{ flex: 1, minWidth: 0 }}
                  >
                    {(() => {
                      const name = item[nameKey] || ''
                      const match = name.match(/[_-](\d+")$|(\d+")$/)
                      if (match) {
                        const timing = match[1] || match[2]
                        const baseName = name.replace(/[_-]\d+"$|\d+"$/, '')
                        return (
                          <div
                            style={{
                              display: 'flex',
                              justifyContent: 'space-between',
                              width: '100%',
                              paddingRight: '10%',
                            }}
                          >
                            <span
                              style={{
                                overflow: 'hidden',
                                textOverflow: 'ellipsis',
                              }}
                            >
                              {baseName}
                            </span>
                            <span
                              style={{ minWidth: '3.5vh', textAlign: 'right' }}
                            >
                              {timing}
                            </span>
                          </div>
                        )
                      }
                      return name
                    })()}
                  </Text>
                  <Text flexShrink={0} wrap={'nowrap'}>
                    {servedCount}
                    {type !== 'messages' ? '/' : null}
                    {type !== 'messages' &&
                      item[
                        type === 'categories'
                          ? 'count'
                          : type === 'assets'
                          ? 'quantity'
                          : 0
                      ]}
                  </Text>
                </ListItemCat>
              )
            }
          })}
        </ListBody>
      </AssetListContainer>
    )
  }

  newAssetsUI(type) {
    const parentCategory = this.props.GameStore.gameAssetCategories.find(
      cat => {
        return cat
          ? type === 'video'
            ? cat.category.toLowerCase() === 'gamemasters'
            : cat.category.toLowerCase() === 'brands'
          : null
      }
    )
    if (!parentCategory) return null
    else
      return (
        <AssetsContainer pTop={2.5}>
          <AssetsHeader>
            <AssetsTitle>{'GAMEMASTER INSERTS'}</AssetsTitle>
            {this.state.selectedCat ? (
              <SearchBarContainer>
                <Label color={'#e5e1e1'} mRight={2}>
                  {'SEARCH: '}
                </Label>
                <SearchInput
                  type="text"
                  value={this.state.searchTxt}
                  onChange={this.handleOnSearch.bind(this)}
                  placeholder=""
                />
              </SearchBarContainer>
            ) : null}
          </AssetsHeader>
          <AssetsBody>
            {this.renderAssetListItems(
              'categories',
              parentCategory.categories,
              this.state.selectedCat,
              '3%',
              'category'
            )}
            {this.state.selectedCat
              ? this.displayAssets(this.state.assetType)
              : null}
            {this.state.selectedAsset
              ? (() => {
                  const msgList =
                    this.state.assetType === 'msg'
                      ? this.props.PrePlayStore.mesVidPlays
                      : this.props.PrePlayStore.gmMesPlays
                  return this.renderAssetListItems(
                    'messages',
                    msgList,
                    this.state.selectedMessage,
                    '0',
                    'name'
                  )
                })()
              : null}
          </AssetsBody>
        </AssetsContainer>
      )
  }

  displayAssets(assetType) {
    let assetsList = this.props.PrePlayStore.combinedGameAssets
      ? this.props.PrePlayStore.combinedGameAssets[assetType]
      : []
    assetsList = _.filter(assetsList, asset => {
      return (
        asset &&
        _.findIndex(asset.category_ids, id => {
          if (this.state.searchTxt) {
            return (
              id === this.state.selectedCat.category_id &&
              (asset.name || '').toLowerCase().includes(this.state.searchTxt)
            )
          } else return id === this.state.selectedCat.category_id
        }) !== -1
      )
    })
    return this.renderAssetListItems(
      'assets',
      assetsList,
      this.state.selectedAsset,
      '3%',
      'name'
    )
  }

  componentWillUnmount() {
    this._isMounted = false
    this.destroyAddToStackItem()
    this.destroyReusePlay()
    this.destroyIsSyncCreatePlay()
    this.destroySyncCreateSession()
    this.destroySyncCreateInterruption()
    this.destroySyncHeaderTeamChange()
  }

  componentDidMount() {
    this._isMounted = true
  }

  render() {
    let { index } = this.props
    let buttonType = this.state.buttonType
    let preItems = this.props.PrePlayStore.getPresetItemsByType(buttonType)

    // let isGameEnded =
    //   this.props.PlayStore.game && this.props.PlayStore.game.progress === 4
    //     ? true
    //     : false

    //let isGameEnded = this.props.GameStore.progress === 'postgame' || this.props.GameStore.progress === 'end'
    /*
    let isGameEnded = this.props.GameStore.dateEndSession ||
                      this.props.GameStore.progress === 'postgame' ||
                      this.props.GameStore.progress === 'end' ||
                      (this.props.GameStore.recordedPlays.length > 2 && 'recording' === this.props.GameStore.executionType) ||
                      this.props.GameStore.isGamePause
*/

    let isGameEnded = this.props.GameStore.disableHeader
    let isImportLocked =
      this.props.GameStore.executionType === 'automation' ||
      this.props.GameStore.progress === 'postgame' ||
      this.props.GameStore.progress === 'ended'

    let isNotYetReadyToStart = this.props.GameStore.isLeap
      ? false
      : 'active, public, pregame'.match(
          new RegExp(this.props.GameStore.progress, 'gi')
        )

    this.automationHeaderButtonStart = `header-button-start-${this.props.AutomationStore.headerPlaySequence}`
    //const automationHeaderButtonEnd = `header-button-end-${this.props.AutomationStore.headerPlaySequence}`
    const automationHeaderButtonEnd = 'header-button-end'
    const automationPreviewButton = `header-preview-button-${this.props.AutomationStore.headerPlaySequence}`
    const automationPlaySequence = this.props.AutomationStore.playSequence
    const { showGameMasterVideoPanel, assetType, isShowAssetsMenu } = this.state
    const { gameAssets } = this.props.PrePlayStore
    const emptyGmMsgs =
      this.props.PrePlayStore.mesVidPlays.length === 0 &&
      this.areGmAssetsEmpty(gameAssets, 'msg')
    const emptyGmVideos =
      this.props.PrePlayStore.gmMesPlays.length === 0 &&
      this.areGmAssetsEmpty(gameAssets, 'video')
    const {
      // showOptionalMessagesDropdown,
      // selectPosition,
      selectMoveButtons,
    } = this.state
    const { type = '' } = { ...this.props.PrePlayStore.currentPlayItem }
    return (
      <Header>
        <BaseWidth>
          <RowTeamsWrapper>{this.RenderTeams(isGameEnded)}</RowTeamsWrapper>
          <ImportButton
            isGameEnded={isImportLocked}
            onClick={isImportLocked ? null : this.handleImportClick.bind(this)}
            title="IMPORT"
          />
          <SelectMoveWrapper>
            {(selectMoveButtons || []).map((button, index) => {
              if (!button) return null
              return (
                <SelectMoveCont
                  onMouseEnter={() => {
                    if (button.name === 'S') this.handleMouseEnterSBtn()
                  }}
                  onMouseLeave={() => {
                    if (button.name === 'S') this.handleMouseLeaveSBtn()
                  }}
                >
                  <SelectMoveButton
                    key={`${index}_${button.id}`}
                    color={
                      this.isCurrentModeActive(button.name)
                        ? '#61891b'
                        : '#eedf14'
                    }
                    backgroundColor={index % 2 === 0 ? '#17c4fe' : '#a7a9ac'}
                    onClick={this.handleSelectMoveClick.bind(this, button.name)}
                  >
                    <span style={{ transform: 'scaleY(1.5)' }}>
                      {button.name}
                    </span>
                    {button.name === 'S' &&
                    this.state.isHoverOnS &&
                    this.props.CommonStore.selectionMode &&
                    (this.props.CommonStore.selectionMode.sModePlays || [])
                      .length ? (
                      <SelectMoveButton
                        color={'#c61818'}
                        backgroundColor={'#eedf14'}
                        onClick={this.handleSelectRemoveAction.bind(this)}
                        position={'absolute'}
                        top={'5vh'}
                        width={responsiveDimension(18)}
                        size={responsiveDimension(1.5)}
                      >
                        <span style={{ transform: 'scaleY(1.3)' }}>
                          {'Remove Selected Plays'}
                        </span>
                      </SelectMoveButton>
                    ) : null}
                  </SelectMoveButton>
                </SelectMoveCont>
              )
            })}
          </SelectMoveWrapper>
          <TypeButtonsWrapper>
            {this.props.PrePlayStore.TypeButtons.map((button, index) => {
              // const refIdButton = `${button.id}-${automationPlaySequence}`
              const refIdButton = `${button.type}`
              return (
                <Fragment key={index}>
                  <RowButton
                    id={refIdButton}
                    innerRef={ref => (this[`type-button-${index}`] = ref)}
                    key={index}
                    disabled={isGameEnded}
                    isGameEnded={isGameEnded}
                    text={button.text}
                    width={button.width}
                    color={'#f1f2f2 !important'}
                    backgroundColor={`${this.getRowButtonBackground(
                      button
                    )} !important`}
                    // onClick={this.handlePlayButtonDDClick.bind(this, refIdButton)}
                    // onChange={this.handleDDOptionChange.bind(this)}
                    onClick={this.handleButtonClick.bind(this, refIdButton)}
                  ></RowButton>
                  {this.state.showDD && button.type === buttonType ? (
                    <DDMenuPlay
                      innerRef={ref => (this[`${this.reference}`] = ref)}
                      display="block"
                      left={
                        buttonType == 'Announce'
                          ? '22.9%'
                          : buttonType == 'GameMaster'
                          ? '5.75%'
                          : buttonType == 'Sponsor'
                          ? '11.45%'
                          : buttonType == 'Prize'
                          ? '17.2%'
                          : '0'
                      }
                    >
                      {buttonType == 'Announce'
                        ? this.props.PrePlayStore.messagePlays.map(
                            (item, i) => {
                              const headerDropdownMessageOptionId = `header-dropdown-message-option-${item.name ||
                                'none'}-${
                                this.props.AutomationStore.headerPlaySequence
                              }`
                              return (
                                <OptionItem
                                  id={headerDropdownMessageOptionId}
                                  style={{
                                    display: this.state.showDD
                                      ? 'flex'
                                      : 'none',
                                  }}
                                  key={i}
                                  onClick={this.handleOptionItemClick.bind(
                                    this,
                                    item,
                                    headerDropdownMessageOptionId
                                  )}
                                >
                                  <Item
                                    color={PlayColors[buttonType.toLowerCase()]}
                                  >
                                    {item.name ? item.name : '-'}
                                  </Item>
                                </OptionItem>
                              )
                            }
                          )
                        : preItems
                            .filter(item => !item.readOnly)
                            .map((item, i) => {
                              const headerDropdownMessageOptionId = `header-dropdown-play-option-${item.preset ||
                                'none'}-${
                                this.props.AutomationStore.headerPlaySequence
                              }`
                              return (
                                <OptionItem
                                  id={headerDropdownMessageOptionId}
                                  style={{
                                    display: this.state.showDD
                                      ? 'flex'
                                      : 'none',
                                  }}
                                  key={i}
                                  onClick={this.handleOptionItemClick.bind(
                                    this,
                                    item,
                                    headerDropdownMessageOptionId
                                  )}
                                >
                                  <Item
                                    color={PlayColors[buttonType.toLowerCase()]}
                                  >
                                    {item.preset}
                                  </Item>
                                </OptionItem>
                              )
                            })}
                    </DDMenuPlay>
                  ) : null}
                </Fragment>
              )
            })}
          </TypeButtonsWrapper>
          <DDSessionWrap>
            <DDInterruption
              //locked={this.props.PrePlayStore.sessionButtons['interruption'].locked}
              locked={isGameEnded}
              index={0}
              readonlyValue={
                this.props.PrePlayStore.sessionButtons['interruption'].value
              }
              value={this.handleInterruptionValue.bind(this)}
              automationAddEvent={this.handleAutomationAddEvent.bind(this)}
            />
          </DDSessionWrap>
          <DDSessionWrap>
            <DDSession
              //locked={this.props.PrePlayStore.sessionButtons['session'].locked}
              locked={isGameEnded}
              index={0}
              readonlyValue={
                this.props.PrePlayStore.sessionButtons['session'].text
              }
              value={this.handleSessionValue.bind(this)}
              automationAddEvent={this.handleAutomationAddEvent.bind(this)}
            />
          </DDSessionWrap>
          <GMButton
            isGameEnded={isImportLocked}
            onClick={e => this.handleGameMasterMenu('video', e)}
            title={'Game Master Video'}
            value="GM"
            backColor={'#19d1bf'}
            disabled={emptyGmVideos}
          >
            <div
              style={{
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                paddingTop: '25%',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <span
                style={{
                  color: '#ffffff',
                  lineHeight: '0.2',
                  fontFamily: 'pamainbold',
                }}
              >
                GM
              </span>
              <span style={{ color: '#c61818', fontFamily: 'pamainbold' }}>
                MES
              </span>
            </div>
          </GMButton>
          {isShowAssetsMenu ? (
            <MesDDMenuPlay
              innerRef={ref => (this.mesDDMenuPlayRef = ref)}
              width={assetType === 'msg' ? '65%' : '60%'}
              isAssetsMenu={true}
              left={assetType === 'msg' ? '9%' : '11%'}
              minHeight={'100px'}
            >
              {/* {this.displayAssets(gameAssets, 'game', assetType)} */}
              {/* {this.displayAssets(gameAssets, 'sportType', assetType)} */}
              {this.newAssetsUI(assetType)}
            </MesDDMenuPlay>
          ) : null}
          <GMButton
            isGameEnded={isImportLocked}
            onClick={e => this.handleGameMasterMenu('msg', e)}
            title="Game Master Message"
            value="GM"
            backColor={'#000000'}
            disabled={emptyGmMsgs}
            assetType="msg"
          >
            <div
              style={{
                paddingTop: '25%',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                alignItems: 'center',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <span
                style={{
                  color: '#19d1bf',
                  lineHeight: '0.2',
                  fontFamily: 'pamainbold',
                }}
              >
                MES
              </span>
              <span style={{ color: '#19d1bf', fontFamily: 'pamainbold' }}>
                VID
              </span>
            </div>
          </GMButton>
          {/* <OptionalMessagesWrapper
            top={`calc(4.5vh + ${this.state.selectPosition.y}px)`}
            left={`calc(15% + ${selectPosition.x}px)`}
          >
            {showOptionalMessagesDropdown &&
              this.props.PrePlayStore.messagePlays.map((item, i) => {
                return (
                  <OptionItem>
                    <Item
                      color={'#333'}
                      onClick={e => {
                        e.stopPropagation
                        this.handleGmAnnounceMenuOptionClick(item, i)
                      }}
                    >
                      {item.name ? item.name : '-'}
                    </Item>
                  </OptionItem>
                )
              })}
          </OptionalMessagesWrapper> */}
          <LFButton
            isGameEnded={isImportLocked}
            title="Live Feed"
            value="LF"
            backColor={'#D3D3D3'}
          >
            <div
              style={{
                paddingTop: '25%',
                color: 'white',
                display: 'flex',
                flexDirection: 'column',
                textAlign: 'center',
                justifyContent: 'center',
              }}
            >
              <span
                style={{
                  color: '#c61818',
                  lineHeight: '0.2',
                  fontFamily: 'pamainbold',
                }}
              >
                LIVE
              </span>
              <span style={{ color: '#c61818', fontFamily: 'pamainbold' }}>
                FEED
              </span>
            </div>
          </LFButton>
          {'automation' === this.props.GameStore.executionType &&
          this.props.GameStore.headless ? (
            <ControlAutomationWrap width="5">
              <DDAutomationController
                baseWidth="5"
                control={this.handleControlClick.bind(this)}
              />
            </ControlAutomationWrap>
          ) : 'recording' === this.props.GameStore.executionType ? (
            <ControlAutomationWrap width="5">
              <RecordingResetButton
                title="RESET"
                onClick={this.handleRecordingResetClick.bind(this)}
              />
            </ControlAutomationWrap>
          ) : null}
          <PreviewButton
            id={automationPreviewButton}
            backgroundColor={
              this.isShownDraggablePreview ? '#008000' : '#17c4fe'
            }
            onClick={
              isGameEnded
                ? null
                : this.handleShowPreviewClick.bind(
                    this,
                    automationPreviewButton
                  )
            }
          />
          <StartSessionButton
            id={this.automationHeaderButtonStart}
            text={this.props.PrePlayStore.sessionButtons['start'].text}
            color={this.props.PrePlayStore.sessionButtons['start'].color}
            backgroundColor={
              isNotYetReadyToStart
                ? '#b0b0b0'
                : this.props.PrePlayStore.sessionButtons['start']
                    .backgroundColor
            }
            locked={
              this.props.GameStore.isRecordEnded
                ? true
                : 'recording' === this.props.GameStore.executionType
                ? false
                : isNotYetReadyToStart
                ? true
                : this.props.PrePlayStore.sessionButtons['start'].locked
            }
            inSession={
              this.props.PrePlayStore.sessionButtons['start'].text === 'On Air'
                ? true
                : false
            }
            onClick={
              this.props.GameStore.isRecordEnded
                ? null
                : 'recording' === this.props.GameStore.executionType
                ? this.handleSessionButtonClick.bind(
                    this,
                    'start',
                    this.automationHeaderButtonStart
                  )
                : this.props.PrePlayStore.sessionButtons['start'].locked
                ? null
                : isNotYetReadyToStart
                ? null
                : this.handleSessionButtonClick.bind(
                    this,
                    'start',
                    this.automationHeaderButtonStart
                  )
            }
            style={{
              width: ['recording', 'automation'].includes(
                this.props.GameStore.executionType
              )
                ? ''
                : '9%',
            }}
          >
            {this.props.PrePlayStore.sessionButtons['start'].text ===
            'On Air' ? (
              <FontAwesomeIcon icon={faCircle} style={RecordingIconStyle} />
            ) : null}
          </StartSessionButton>
          {/* <DDSessionWrap>
            <DDMessage
              //locked={this.props.PrePlayStore.sessionButtons['interruption'].locked}
              locked={isGameEnded}
              index={0}
              readonlyValue={
                this.props.PrePlayStore.sessionButtons['message'].value
              }
              value={this.handleMessageValue.bind(this)}
              automationAddEvent={this.handleAutomationAddEvent.bind(this)}
            />
          </DDSessionWrap> */}
          {/* <SponsorBrandWrapper>
            <DDSponsorBrand
              item={null}
              locked={isGameEnded}
              height={h}
              index={'header-0'}
              value={this.handleSelectedSponsor.bind(this)}
              automationAddEvent={this.handleAutomationAddEvent.bind(this)}
              isHeader={true}
            />
          </SponsorBrandWrapper> */}
          <EndSessionButton
            id={automationHeaderButtonEnd}
            text={this.props.PrePlayStore.sessionButtons['end'].text}
            color={this.props.PrePlayStore.sessionButtons['end'].color}
            backgroundColor={
              this.props.PrePlayStore.sessionButtons['end'].backgroundColor
            }
            locked={
              this.props.PrePlayStore.sessionButtons['end'].locked ||
              (this.props.PrePlayStore.unresolvedItems &&
                this.props.PrePlayStore.unresolvedItems.length > 0) ||
              type != 'Announce' ||
              !this.isPrepicksResolved()
            }
            display={this.props.GameStore.progress == 'live' ? 'flex' : 'none'}
            onClick={this.handleSessionButtonClick.bind(
              this,
              'end',
              automationHeaderButtonEnd
            )}
            style={{
              width: ['recording', 'automation'].includes(
                this.props.GameStore.executionType
              )
                ? ''
                : '8.5%',
            }}
          />
          <ToggleBGColor onClick={this.handleToggleBgColor.bind(this)} />
          {/* <GameType>{this.props.GameStore.gameId}</GameType> */}
          {/*<GameType>{this.props.AutomationStore.currentTime}</GameType>*/}
          {/*<GameType>{this.props.AutomationStore.headerPlaySequence} {this.props.AutomationStore.currentTime}</GameType>*/}
          {/*<GameType>{'NAV ' + navigator.webdriver + ' - ' + this.props.GameStore.executionType}</GameType>*/}

          {/*TO BE DELETED <ResetButton onClick={this.handleResetDBClick.bind(this)}>*/}
          {/*  RESET DB*/}
          {/*</ResetButton>*/}
        </BaseWidth>

        {(!this.props.GameStore.dateEndSession ||
          !this.props.GameStore.isRecordEnded) &&
        this.props.GameStore.sessionMode &&
        (!this.props.PrePlayStore.preplayItems ||
          (this.props.PrePlayStore.preplayItems &&
            this.props.PrePlayStore.preplayItems.length < 1)) &&
        !this.props.PrePlayStore.nextPlayItem
          ? null
          : null}
      </Header>
    )
  }
}

const h = 5
let FONT_SIZE = '1.6vh'

const MesDDMenuPlay = styled.div`
  display: ${props => props.display};
  left: ${props => props.left || ''};
  z-index: 1000 !important;
  position: absolute;
  background-color: rgba(20, 71, 83, 0.8);
  background-image: linear-gradient(
    to bottom,
    rgba(41, 160, 190, 0.8) 0%,
    rgba(20, 71, 83, 0.1) 20px,
    /* Lighter at the top */ rgba(20, 71, 83, 0.1) calc(100% - 20px),
    /* Lighter at the bottom */ rgba(41, 160, 190, 0.8) 100%
  );
  border-radius: 0 0 10px 10px;
  min-width: ${props => (props.width ? props.width : '160px')};
  min-height: ${props => props.minHeight || ''};
  overflow: ${props => (props.isAssetsMenu ? 'hidden' : 'auto')};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  margin-top: ${props => (props.isAssetsMenu ? '' : h)}vh;
  top: ${props => props.isAssetsMenu && `${h}vh`};
  box-shadow: 0px 16px 26px rgba(0, 0, 0, 0.5),
    /* Base shadow */ 0px 4px 10px rgba(255, 255, 255, 0.2) inset,
    /* Inner glow for satin effect */ 0px -4px 8px rgba(255, 255, 255, 0.1);
`

const DDMenuPlay = styled.div`
  display: ${props => props.display};
  margin-left: ${props => props.left};
  z-index: 1000 !important;
  position: absolute;
  background-color: #f1f1f1;
  width: ${props => (props.width ? props.width : 'max-content')};
  max-width: ${props => (props.maxWidth ? props.maxWidth : '450px')};
  max-height: 90vh;
  overflow-x: hidden;
  overflow-y: ${props => (props.isAssetsMenu ? 'hidden' : 'auto')};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
  margin-top: ${props => (props.isAssetsMenu ? '' : h)}vh;
  top: ${props => props.isAssetsMenu && `${h}vh`};

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: 1vh;
  }
  &::-webkit-scrollbar {
    width: 1vh;
    background-color: #f5f5f5;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    border-radius: 1vh;
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
  }
`

const AssetsContainer = styled.div`
  padding-top: ${props => (props.pTop ? responsiveDimension(props.pTop) : '')};
`

const AssetsHeader = styled.div`
  width: 100%;
  padding: 0 ${responsiveDimension(3)};
  display: flex;
  justify-content: space-between;
`

const AssetsTitle = styled.div`
  display: flex;
  font-family: pamainBold;
  font-size: ${responsiveDimension(2.5)};
  color: #fff;
`

const SearchBarContainer = styled.div`
  display: flex;
  align-items: center;
`

const Label = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  font-family: ${props => props.font || 'pamainregular'};
  font-size: ${props => responsiveDimension(props.size || 2)};
  color: ${props => props.color || '#fff'};
  margin-right: ${props => responsiveDimension(props.mRight || 0)};
`

const SearchInput = styled.input`
  width: ${props => responsiveDimension(20)};
  height: ${props => responsiveDimension(4.2)};
  padding: ${responsiveDimension(1)} ${responsiveDimension(1)};
  border-radius: 3px;
  background-color: #b4b4b4;
  color: #4e4e4e;
  border: none;
  font-family: pamainregular;
  font-size: ${responsiveDimension(2.5)};
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.5);

  ::placeholder {
    color: #4e4e4e;
    font-family: pamainregular;
    font-size: ${responsiveDimension(2.5)};
  }

  &:focus {
    outline: none;
    box-shadow: none;
    border: none;
  }
`

const AssetsBody = styled.div`
  width: 100%;
  padding: ${responsiveDimension(2)} ${responsiveDimension(2.5)};
  display: flex;
`

const AssetListContainer = styled.div`
  width: ${props =>
    props.type === 'assets'
      ? '50%'
      : props.type === 'categories' || props.type === 'messages'
      ? '22%'
      : '33%'};
  height: ${props =>
    props.length ? responsiveDimension(3 * (props.length + 2)) : 'auto'};
  max-height: ${responsiveDimension((23 + 2) * 3)};
  background-color: #dcdcdc;
  border-radius: 10px;
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.5);
  margin-right: ${props => props.mRight || ''};
  box-sizing: border-box;
`

const ListHeader = styled.div`
  display: flex;
  align-items: center;
  width: 100%;
  height: 30px;
  font-family: pamainregular;
  font-size: ${responsiveDimension(2)};
  background-color: #fff;
  color: #000;
  border-radius: 10px;
  box-shadow: 5px 0px 5px rgba(0, 0, 0, 0.5);
  padding: ${responsiveDimension(1)};
  text-wrap: nowrap;
  white-space: nowrap;
  overflow-x: auto;
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
`

const ListBody = styled.div`
  width: 96%;
  height: ${props =>
    props.length ? responsiveDimension(3 * (props.length + 0.5)) : 'auto'};
  max-height: ${responsiveDimension(23 * 3)};
  overflow-y: auto;
  margin: ${responsiveDimension(1)} ${responsiveDimension(0.5)};
  box-sizing: border-box;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: transparent;
    border-radius: ${props => 1}vh;
    border: solid 1px #262626;
  }

  &::-webkit-scrollbar {
    width: 4px;
    border-radius: 2px;
  }

  &::-webkit-scrollbar-thumb {
    background: red;
    border-radius: 2px;
    border: solid 1px #262626;
  }
`

const ListItemCat = styled.div`
  width: 100%;
  height: ${responsiveDimension(3)};
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: ${responsiveDimension(2)};
  font-family: pamainregular;
  color: ${props => (props.isSelected ? '#fff' : '#000')};
  background-color: ${props => (props.isSelected ? '#818181' : '')};
  padding: ${responsiveDimension(0.4)} ${responsiveDimension(0.5)} 0;
  box-sizing: border-box;
`

const Text = styled.div`
  display: flex;
  width: ${props => props.width || ''};
  height: 100%;
  overflow-x: auto;
  overflow-y: hidden;
  text-wrap: ${props => props.wrap || ''};
  white-space: ${props => props.wrap || ''};
  margin-right: ${props => props.mRight || ''};
  padding-right: ${props => props.pRight || ''};
  align-items: center;
  flex-shrink: ${props =>
    props.flexShrink !== undefined ? props.flexShrink : ''};
  box-sizing: border-box;

  &::-webkit-scrollbar {
    display: none;
  }
`

const OptionalMessagesWrapper = styled.div`
  display: flex;
  position: absolute;
  z-index: 10000;
  flex-direction: column;
  width: ${vhToPx(15.1)};
  background-color: #f1f1f1;
  top: ${props => props.top};
  left: ${props => props.left};
  box-shadow: 0px 8px 16px 0px rgba(0, 0, 0, 0.2);
`

const Headercontainer = styled.div`
  width: 100%;
  display: flex;
  align-items: center;
`

const ListContainer = styled.div`
  max-height: ${vhToPx(5 * h)};
  overflow: auto;

  &::-webkit-scrollbar-track {
    -webkit-box-shadow: inset 0 0 0.3vh rgba(0, 0, 0, 0.3);
    background-color: #f5f5f5;
    border-radius: ${props => 1}vh;
  }
  &::-webkit-scrollbar {
    width: ${props => 0.2}vh;
    background-color: #f5f5f5;
    height: ${props => 0.2}vh;
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgba(255, 0, 0, 0.6);
    &:hover {
      background-color: rgba(255, 0, 0, 1);
    }
    border-radius: ${props => 1}vh;
  }
`

const HorizontalBar = styled.div`
  width: ${props => (props.width ? props.width : '')};
  height: ${props => (props.height ? vhToPx(props.height) : '')};
  background-color: #858989;
  margin-left: ${props => props.mLeft};
  margin-right: ${props => props.mRight};
`

const HeaderName = styled.div`
  width: ${props => (props.width ? props.width : '')};
  padding: 0 10px;
  display: flex;
  justify-content: center;
  font-family: pamainregular;
  font-size: ${responsiveDimension(1.9)};
  color: #ff0000;
  text-wrap: nowrap;
  opacity: 0.5;
`

const OptionItem = styled.div`
  width: auto;
  height: ${vhToPx(h)};
  min-height: 3.5vh;
  padding: 0.5vh 1vh;
  // display: flex;
  opacity: ${props => (props.opaque ? 0.5 : 1)};
  &:hover {
    background-color: ${props => props.assetsOption && '#d3d3d3'};
  }
`

const Item = styled.div`
  width: ${props => (props.noWidth ? '' : props.width || '100%')};
  justify-content: center;
  align-items: center;
  font-family: pamainregular;
  font-size: ${props => FONT_SIZE};
  color: ${props => props.color || '#000000'};
  text-transform: uppercase;
  &:hover {
    background-color: ${props => (props.noAssets ? '' : '#d3d3d3')};
  }
  padding: ${props => props.padding || '0 0.5vh'};
  white-space: ${props => props.whiteSpace || 'nowrap'};
`

const ServingCounter = styled.div`
  display: flex;
  flex-direction: row;
  width: 25%;
  justify-content: end;
`

const Header = styled.div`
  width: 100%;
  height: ${props => h}vh;
  //background-color: #f1f2f2;
  font-family: pamainbold;
  font-size: ${FONT_SIZE};
  background-color: #ffffff;
  position: fixed;
  z-index: 1000;
`

const BaseWidth = styled.div`
  //width: 93vw;
  width: ${props => 100}vw;
  background-color: ${props => props.backgroundColor};
  display: flex;
  flex-direction: row;
  height: inherit;
`

const RowTeamsWrapper = styled.div`
  width: 23%;
  height: inherit;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #fff;
`

const SelectMoveWrapper = styled.div`
  width: 6%;
  height: inherit;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  border-bottom: 1px solid #fff;
`

const SelectMoveCont = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
`

const SelectMoveButton = styled.div`
  width: ${props => props.width || '100%'};
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${props => props.size || responsiveDimension(2)};
  color: ${props => props.color || '#eedf14'};
  background-color: ${props => props.backgroundColor};
  text-transform: uppercase;
  cursor: pointer;
  position: ${props => props.position || ''};
  top: ${props => props.top || ''};
`

const TypeButtonsWrapper = styled.div`
  width: 29%;
  display: flex;
  flex-direction: row;
`

const PreviewButton = styled.div`
  width: 3%;
  min-width: 2.5%;
  height: ${props => 5}vh;
  background-image: url(${PreviewIcon});
  background-repeat: no-repeat;
  background-size: 70%;
  background-position: center;
  background-color: ${props => props.backgroundColor};
  cursor: pointer;
  margin-right: 0.1vh; 
/*
  background-color: #f1f2f2;
  &:after {
    content: '';
    display: inline-block;
    width: 100%;
    height: 100%;
    background-color: #008000;
    -webkit-mask-image: url(${PreviewIcon});
    -webkit-mask-size: 50%;
    -webkit-mask-repeat: no-repeat;
    -webkit-mask-position: center;
    mask-image: url(${PreviewIcon});
    mask-size: 60%
    mask-repeat: no-repeat;
    mask-position: center;
  }
*/
border-bottom: 1px solid #fff;
`

const SessionRowInfo = styled.div`
  width: 35%;
  height: inherit;
  display: flex;
  justify-content: space-between;
`

const StartSessionButton = styled.div`
  width: 8%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: 2vh;
  color: ${props => props.color || '#969696'};
  background-color: ${props => props.backgroundColor};
  text-transform: uppercase;
  line-height: 1;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  &:after {
    content: '${props => props.text}';
  }
  -webkit-filter: ${props =>
    props.locked && !props.inSession ? 'grayscale(1)' : 'grayscale(0)'};
  border-bottom: 1px solid #fff;
`

const ImportButton = styled.div`
  width: 3%;
  height: ${props => h}vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: #bebebe;
  cursor: ${props => (props.isGameEnded ? 'default' : 'pointer')};
  &:after {
    width: ${props => 35}vh;
    height: ${props => h}vh;
    content: '';
    display: inline-block;
    background-image: url(${PlayTypeIcon});
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
  }
  &:hover:after {
    ${props => (props.isGameEnded ? `` : `background-size: 80%;`)};
  }
  border-bottom: 1px solid #fff;
`
const GMButton = styled.div`
  width: 3%;
  min-width: 2.5%;
  height: 5vh;
  font-family: pamainbold;
  font-size: 2.1vh;
  display: flex;
  // justify-content: center;
  align-items: center;
  background-color: ${props => props.backColor || 'ffffff'};
  cursor: ${props => (props.isGameEnded ? 'default' : 'pointer')};
  background-image: url(${props =>
    props.locked
      ? ''
      : props.assetType === 'msg'
      ? WhiteArrowIcon
      : UpArrowIcon});
  background-repeat: no-repeat;
  background-position: bottom ${props => -0.4}vh right;
  background-size: ${props => 1.4}vh;
  &:after {
    // width: ${props => 35}vh;
    // height: ${props => h}vh;
    content: '';
    // justify-content: center;
    // align-items: center;
    display: inline-block;
    color: white;
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
  }
  &:hover:after {
    ${props => (props.isGameEnded ? `` : `background-size: 80%;`)};
  }
  border-bottom: 1px solid #fff;
  ${props =>
    props.disabled &&
    `
    pointer-events: none;  // Makes the div non-interactive
    opacity: 0.5;          // Grays out the div
    user-select: none;     // Prevents text selection
  `}
`

const LFButton = styled.div`
  width: 3%;
  min-width: 2.5%;
  height: 5vh;
  font-family: pamainbold;
  font-size: 2.1vh;
  display: flex;
  justify-content: center;
  align-items: center;
  background-color: ${props => props.backColor || 'ffffff'};
  cursor: ${props => (props.isGameEnded ? 'default' : 'pointer')};
  background-image: url(${props => (props.locked ? '' : UpArrowIcon)});
  background-repeat: no-repeat;
  background-position: bottom ${props => -0.4}vh right;
  background-size: ${props => 1.4}vh;
  border-bottom: 1px solid #fff;
  &:after {
    // width: ${props => 35}vh;
    // height: ${props => h}vh;
    content: '';
    justify-content: center;
    align-items: center;
    display: inline-block;
    color: white;
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
  }
  &:hover:after {
    ${props => (props.isGameEnded ? `` : `background-size: 80%;`)};
  }
`

const RowButton = styled.div`
  width: 100%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${FONT_SIZE};
  color: ${props => props.color || '#969696'};
  background-color: ${props => props.backgroundColor};
  text-transform: uppercase;
  line-height: 1;
  background-image: url(${props => (props.locked ? '' : UpArrowIcon)});
  background-repeat: no-repeat;
  background-position: bottom ${props => -0.4}vh right;
  background-size: ${props => 1.4}vh;
  cursor: ${props => (props.isGameEnded ? 'default' : 'pointer')};
  &:after {
    content: '${props => props.text}';
  }
  border-bottom: 1px solid #fff;
`

const SponsorBrandWrapper = styled.div`
  width: 13%;
  height: ${props => h}vh;
  position: relative;
`

const EndSessionButton = styled.div`
  width: 8%;
  height: inherit;
  display: ${props => props.display};
  justify-content: center;
  align-items: center;
  font-family: pamainbold;
  font-size: ${FONT_SIZE};
  color: ${props => props.color || '#969696'};
  background-color: ${props => props.backgroundColor};
  text-transform: uppercase;
  line-height: 1;
  cursor: ${props => (props.locked ? 'default' : 'pointer')};
  pointer-events: ${props => (props.locked ? 'none' : '')};
  &:after {
    content: '${props => props.text}';
  }
  -webkit-filter: ${props =>
    props.locked && !props.inSession ? 'grayscale(1)' : 'grayscale(0)'};
  border-bottom: 1px solid #fff;
`

const GameType = styled.div`
  width: 15.5%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  text-transform: uppercase;
`

const ResetButton = styled.div`
  width: 15%;
  display: flex;
  justify-content: center;
  align-items: center;
  background: #ff0000;
  color: #ffffff;
  font-family: pamainextrabold;
  font-size: ${FONT_SIZE};
  cursor: pointer;
`

const TeamWrappercontainer = styled.div`
  display: flex;
  width: 100%;
  height: inherit;
`

const TeamWrapper = styled.div`
  width: 100%;
  height: ${props => h}vh;
  display: flex;
  //justify-content: space-between;
  flex-direction: row;
  justify-content: center;
  cursor: pointer;
`

const TeamLabel = styled.div`
  //width: 100%;
  height: inherit;
  text-transform: uppercase;
  display: flex;
  justify-content: center;
  align-items: center;
  //padding-left: 10%;
  margin-right: ${props => vwToPx(0.2)};
`

const ScoreInput = styled.input`
  width: 3.5vh;
  height: 2.5vh;
  border-radius: 0 33% 33% 0;
  border: none;
  color: #000;
  &:focus {
    border: none;
    color: #000;
    outline: none;
  }
  &:focus-visible {
    border: none;
    color: #000;
  }
  &:visited {
    border: none;
    color: #000;
  }
  padding-left: 1.7vh;
  z-index: 5;
`

const ScoreInputWrapper = styled.div`
  position: relative;
`

const InputCircle = styled.div`
  position: absolute;
  left: 0px;
  height: 2.5vh;
  width: 2.5vh;
  left: -1.75vh;
  border-radius: 50%;
  z-index: 10;
`

const TeamCircleWrapper = styled.div`
  //width: 100%;
  height: inherit;
  display: flex;
  justify-content: center;
  align-items: center;
  padding-right: 10%;
`

const DDSessionWrap = styled.div`
  width: 3.5%;
  height: 100%;
  position: relative;
  border-bottom: 1px solid #fff;
`

const ControlAutomationWrap = styled.div`
  width: ${props => props.width}vh;
  height: inherit;
  display: flex;
  border-bottom: 1px solid #fff;
`

const RecordingResetButton = styled.div`
  width: 100%;
  height: inherit;
  background-color: #d3d3d3;
  cursor: pointer;
  border: 1.5px solid #000000;
  &:after {
    width: 100%;
    height: 100%;
    content: '';
    display: inline-block;
    background-image: url(${props => evalImage('record-reset-icon.svg')});
    background-repeat: no-repeat;
    background-size: 70%;
    background-position: center;
  }
  &:hover:after {
    animation: ${props => imgRotate} 5s linear infinite;
  }
`

const imgRotate = keyframes`
  to {
    transform: rotate(-360deg);
  }
`

const Arrow = styled.div`
  position: absolute;
  bottom: 100%;
  left: 70%;
  width: 4vh;
  height: 2vh;
  overflow: hidden;
  &:after {
    content: '';
    position: absolute;
    width: 2vh;
    height: 2vh;
    left: 50%;
    transform: translate(-50%, 50%) rotate(45deg);
    background-color: #ff0000;
    box-shadow: 0 1px 8px rgba(0, 0, 0, 0.5);
  }
`

const RecordingIconStyle = {
  color: 'rgb(233, 7, 7)',
  'box-shadow': 'rgb(255, 255, 255) 0px 0px 12px 5px',
  'background-color': 'rgb(233, 7, 7)',
  'border-radius': '50%',
  'margin-right': '1vh',
  width: '2vh',
  height: '2vh',
  opacity: 0.9,
}

const CounterContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  background-color: #414042;
`

const CountButton = styled.button`
  background-color: transparent;
  border: none;
  width: 40px;
  height: 40px;
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 20px;
  color: #fff;
  height: 2.5vh;
  &:hover {
    background-color: #18c5ff;
  }
`

const ToggleBGColor = styled.div`
  width: 2.6%;
  height: 100%;
  background: linear-gradient(
    135deg,
    ${BACKGROUND.light} 50%,
    ${BACKGROUND.dark} 50%
  );
  cursor: pointer;
  border-bottom: 1px solid #fff;
`

const IncrementButton = styled(CountButton)``

const DecrementButton = styled(CountButton)``

const IncrementIconStyle = {
  height: '2.2vh',
  width: '2.2vh',
  color: '#ffffff',
  'padding-top': '2vh',
}

const DecrementIconStyle = {
  height: '2.2vh',
  width: '2.2vh',
  color: '#ffffff',
  'margin-bottom': '-0.8vh',
}



// WEBPACK FOOTER //
// src/Components/CommandHost/HeaderPanel.js